<template>
  <div :class="[$style.container, isActive && $style.containerActive]" v-click-outside="onClickOutside">
    <div :class="$style.current" @click="onOpen">
      {{ activeFilter.title }}
      <feather-icon :class="[$style.icon, activeFilter.order === 'asc' && $style.iconUp]" icon="ChevronDownIcon" />
    </div>
    <div :class="[$style.popup, isActive && $style.popupActive]">
      <div v-for="filter in filters" :class="$style.option" @click="onSetSort(filter.sort, filter.order)">
        {{ filter.title }}
        <feather-icon :class="[$style.icon, filter.order === 'asc' && $style.iconUp]" icon="ChevronDownIcon" />
      </div>
    </div>
  </div>
</template>

<script>
const filters = [
  {
    sort:  'id',
    order: 'desc',
    title: 'Сначала новые',
  },
  {
    sort:  'id',
    order: 'asc',
    title: 'Сначала старые',
  },
];

export default {
  name:     "IssueSortFilter",
  props:    ['sort', 'order'],
  data() {
    return {
      isActive: false,
      filters,
    };
  },
  computed: {
    activeFilter() {
      if (!this.order && !this.sort) return filters[0];
      return filters.find(f => f.order === this.order && f.sort === this.sort) || { title: 'Неизвестно' };
    },
  },
  methods:  {
    onClickOutside() {
      this.isActive = false;
    },
    onOpen() {
      this.isActive = true;
    },
    onSetSort( sort, order ) {
      this.$emit('update', sort, order);
      this.isActive = false;
    },
  },
};
</script>

<style lang="scss" module>
.container {
  display: inline-flex;
  position: relative;
}

.containerActive {
  .current {
    background: color(primary);
    color: #ffffff;
  }
}

.current {
  @include anim();
  padding: 4px 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: 2px;

  //&:hover {
  //  background: color(primary);
  //  color: #ffffff;
  //}
}

.icon {
  width: 18px;
  height: 18px;
}

.iconUp {
  transform: rotate(180deg);
}

.popup {
  display: none;
  position: absolute;
  left: 0;
  top: 100%;
  margin-top: 4px;
  background: #FFFFFF;
  border-radius: 2px;
  min-width: 100%;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
  padding: 8px 0;
}

.popupActive {
  display: block;
}

.option {
  padding: 4px 8px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  cursor: pointer;
  @include anim();

  &:hover {
    background: #F2F3F6;
  }
}
</style>
